import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Notification, NotificationService, SearchResultsRepositoryService } from 'reg-hub-common';

@Component({
    selector: 'app-asset-search-notification',
    templateUrl: './asset-search-notification.component.html',
    styleUrl: './asset-search-notification.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetSearchNotificationComponent {
  @Input() notification!: Notification;
  protected serialNumber: string | null | undefined;
  protected numResults = 0;
  protected show = false;

  constructor(
    private notificationService: NotificationService,
    private router: Router,
    private searchResultsService: SearchResultsRepositoryService) { }

  ngOnInit(): void {
    this.searchResultsService.getSearchSummaryAsJson(this.notification.order!.id).subscribe(summary => {
      this.show = true;
      this.serialNumber = summary.criteria;
      this.numResults = summary.total ?? 0;
    })
  }

  removeNotification() {
    this.notificationService.removeNotification(this.notification.id);
  }

  viewOrder() {
    this.notificationService.removeNotification(this.notification.id);

    if(this.notification.shouldNavigationOpenTab) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['orders', this.notification.order!.id])
      );

      window.open(url, '_blank');
    } else {
      this.router.navigate(['orders', this.notification.order!.id]);
    }
  }
}
